import { GroupChatMember, MemberRole } from "./member";
import { EncryptedLastMessage, EncryptedMessage } from "./message";
import { UserAsMemberOfGroupChatData } from "./user";

enum ChatType {
  P2P = 1,
  GROUP = 2,
  NOTE = 3,
}

type EnrichedChatList = {
  enriched_chats: GroupChatEntity[];
  enriched_p2p_chats: P2PChatEntity[];
  enriched_notes: EnrichedNotes;
};

type GetEnrichedChatListPayload = {
  messages_take?: number;
  chats_take?: number;
  chats_skip?: number;
};

type EnrichedNotes = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  messages: any[]; // TO DO - Check what type of messages are returned or if is something being returned
};

// TO DO => Talk with team about this
// same type used in PATCH requests -> all fields are required ??
type GroupChatResponseType = {
  id: string;
  name: string;
  picture: string; // TO DO - Check if nullable
  is_private_p2p: boolean;
  member_count: number;
  timestamp: number;
  last_message: EncryptedLastMessage | null; // TO DO - Check if nullable
  description: string;
  is_searchable: boolean;
  can_post: MemberRole | null;
  threads_enabled: boolean | null;
  hub_id: string | null;
  current_epoch?: number; // CSK rotation epoch (0 = original key, absent = epoch 0)
};

type GroupChatEntity = {
  chat: GroupChatResponseType;
  member: UserAsMemberOfGroupChatData;
  // messages: any[]; // TO DO - Check what type of messages are returned or if is something being returned
  unread_count: number;
  is_pinned: boolean;
  is_archived: boolean;
  pinned_messages: EncryptedMessage[];
};

// TO DO => Talk with team about this
// same type used in PATCH requests -> all fields are required ??
type P2PChatResponseType = {
  id: string;
  user_one: string;
  // JSON string with the peer's { username, profile_image, public_keys }.
  // public_keys is the peer's public key material, surfaced so this client can
  // encapsulate a rotated CSK to them during forward-secrecy key rotation.
  user_two: string;
  secure_payload: string;
  settings: string; /// ????
  timestamp: number;
  current_epoch?: number; // CSK rotation epoch (0 = original key); absent on legacy docs
  last_message?: EncryptedLastMessage; // TO DO - Check if nullable
};

type P2PChatEntity = {
  p2p_chat: P2PChatResponseType;
  // messages: any[]; // TO DO - Check what type of messages are returned or if is something being returned
  unread_count: number;
  is_pinned: boolean;
  is_archived: boolean;
  pinned_messages: EncryptedMessage[];
};

type CreateP2pChatPayload = {
  id?: string;
  user_one: string;
  user_two: string;
  secure_payload: string;
  settings?: string;
};

type CreateGroupChatPayload = {
  chat: GroupChatResponseType;
  members: GroupChatMember[];
};

type GetSearchableGroupChatPayload = {
  prefix: string;
  accessor: string;
  offset?: number;
  count?: number;
};

type SearchableGroupChatResponse = {
  id: string;
  name: string;
  picture?: string;
  description?: string;
};

type PublicGroupJoinRequestPayload = {
  chat_id: string;
  public_keys: string;
};

type PublicGroupUsersRequests = {
  username: string;
  public_keys: string;
}[];

// types
export type {
  EnrichedChatList,
  EnrichedNotes,
  GroupChatEntity,
  P2PChatEntity,
  CreateP2pChatPayload,
  CreateGroupChatPayload,
  GetEnrichedChatListPayload,
  GetSearchableGroupChatPayload,
  SearchableGroupChatResponse,
  GroupChatResponseType,
  P2PChatResponseType,
  PublicGroupJoinRequestPayload,
  PublicGroupUsersRequests,
};

// enums
export { ChatType };
